const wortHost = 'www.wort.lu';
const luxtimesHost = 'www.luxtimes.lu';
//const ssoHost = 'user.wort.lu';
const notifHost = 'jobsv3.wort.lu';

const APP_CONF = {
    //domain                  : '.wort.lu',
    //host                    : wortHost,
    webHost_wort            : `https://${wortHost}`,
    webHost_luxtimes        : `https://${luxtimesHost}`,

    //ssoHost                 : `https://${ssoHost}`,
    googleMapApiKey         : "AIzaSyD6-3zWECLefyBT6PnLMCQAr9P6d0bhR78",
 
};
module.exports = APP_CONF;



// WEBPACK FOOTER //
// ../conf/prod.js